import type { GetQuizsetRankingsSchoolType } from '@/api/gen/_model/getQuizsetRankingsSchoolType';
import { useGetQuizsetRankings } from '@/api/gen/quizset-ranking/quizset-ranking.gen';
import { useSelectedFeaturedQuiz } from '@/module/featured/useSelectedFeaturedQuiz';
import { useCountryCode } from '@/shared/hooks';

export const useFetchQuizsetRankings = () => {
  const { countryCode, isLoading } = useCountryCode();
  const { selectedSchoolType, selectedPeriod } = useSelectedFeaturedQuiz();
  const result = useGetQuizsetRankings(
    {
      countryCode: countryCode,

      ...(selectedSchoolType !== 'ALL' && {
        schoolType: selectedSchoolType as GetQuizsetRankingsSchoolType,
      }),
      period: selectedPeriod,
    },
    {
      query: {
        enabled: !isLoading,
      },
    },
  );

  return {
    ...result,
    isLoading: isLoading || result.isLoading,
  };
};
